import { render, staticRenderFns } from "./BroadbandConnectionAnalysis.vue?vue&type=template&id=36840bd6"
import script from "./BroadbandConnectionAnalysis.vue?vue&type=script&lang=js"
export * from "./BroadbandConnectionAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports